module.exports = __webpack_public_path__ + "img/key-01.06a09060.svg";